import { useEffect, useState } from 'react';
export function useFlowData(getFlowItem, flowId) {
    const [actions, setActions] = useState(null);
    const [active, setActive] = useState(true);
    const [messengerId, setMessengerId] = useState();
    useEffect(() => {
        if (!flowId)
            return;
        getFlowItem(flowId).then((res) => {
            setActions(res.data.actions);
            setActive(res.data.active);
            setMessengerId(res.data.location);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [flowId]);
    return { actions, active, messengerId, setActions, setActive };
}
